export const PROJECT_TOPIC = '/topic/project';
export enum ProjectMessages {
  UserConnected = 'UserConnectedToProject',
  LogMessage = 'LogMessage',
  // ProjectUpdated = 'ProjectUpdated',
  // ProjectDeleted = 'ProjectDeleted',
  // QuoteCreated = 'QuoteCreated',
  // ProjectStatusUpdated = 'ProjectStatusUpdated',
  // QuoteStatusUpdated = 'QuoteStatusUpdated',
}
